import { render } from "./VerifyEmail.vue?vue&type=template&id=9a976bca"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"

import exportComponent from "/home/dschranka/actions-runner/_work/DSchranka/DSchranka/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__